import { useHasPermission } from '../../hooks/useHasPermission';
import { Box, Typography, useMediaQuery } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import { useTranslation } from 'react-i18next';
import Iconify from '../Iconify';
import React from 'react';
import '../../css/companies/companiesPageHeader.css';

const CompaniesPageHeader = ({ setOpenAddCompany }) => {

    const { t } = useTranslation();
    const theme = useTheme();
    const isDesktop = useMediaQuery(theme.breakpoints.up('md'));
    const hasCompaniesCreatePermission = useHasPermission('entreprise_create');

    return (
        <Box className='company_headre_main_container'>
            <Box className='company_headre_title_box'>
                <Typography className='company_headre_page_title'>Entreprises</Typography>
            </Box>
            {(isDesktop && hasCompaniesCreatePermission) &&
                <Box className='company_headre_action_box' onClick={() => setOpenAddCompany(true)}>
                    <Iconify className='company_headre_add_icon' icon="ic:baseline-plus" />
                    <Typography className='company_headre_action_title'>{t("addCompanyButtonTitle")}</Typography>
                </Box>
            }
            {(!isDesktop && hasCompaniesCreatePermission) &&
                <Box className='company_headre_action_box'>
                    <Iconify className='company_headre_add_icon' icon="ic:baseline-plus" onClick={() => setOpenAddCompany(true)} />
                </Box>
            }
        </Box>
    );
};

export default React.memo(CompaniesPageHeader);